import React from 'react';
import { Outlet } from 'react-router-dom';
import ChatSplit from '../components/AgentChat/ChatSplit';

/**
 * ChannelLayout - Layout wrapper for channel pages
 * 
 * Note: Channel pages have their own ChannelAppBar and FooterBar with 
 * specific state management (archive filters, unlinked count toggle, etc.)
 * So this layout is minimal - it just provides the structural wrapper
 * and lets ChannelComponent handle its own navbar/footer.
 */
const ChannelLayout = () => {
    return (
        <ChatSplit>
            <Outlet />
        </ChatSplit>
    );
};

export default ChannelLayout;

